import React from 'react';
import { Switch, Router, Route, withRouter, matchPath } from 'react-router-dom';
import { serviceProfile } from '../../services/service-profile';
import { btDirname } from '../../utils/bt-string';
import { ServiceChat } from '../../services/service-chat';
import { ServiceProjects } from '../../services/service-projects';
import { serviceAreas } from '../../services/service-areas';
import { NotificationManager } from 'react-notifications';
import AppCreateProject from '../app-create-project/app-create-project';
import PageProjectsSingle from './page-projects-single';
import '../app-select-industry-types/app-select-industry-types.css';
import SupplierDatabase from '../app-supplier-database/supplier-database';
import { PageSupplierMonitoring } from '../page-supplier-monitoring/page-supplier-monitoring';
import PageInternalChat from '../page-internal-chat/page-internal-chat';
import PageProjectInternList from './page-project-intern-list';
import PageProjectsSingleInbox from './page-projects-single-inbox';
import PageProjectsStart from './page-projects-start';
import AppAddSupplier from '../app-add-supplier/app-add-supplier';
import './page-projects.css';
import ProjectStrategy from './project-strategy';
import appState from '../../state/AppStateContainer';
import appEnum from '../../util/appEnum';
import PageProjectUsersAreas from './page-project-users-areas';
import ReactTooltip from 'react-tooltip';
import $ from 'jquery';
import Organization from '../page-organization/page-organization';
import PageOrganizationApplications from '../page-organization/PageOrganizationApplications';
import PageTips from '../page-tips/page-tips';
import Modal from '../../components/shared/Modal/Modal';
import { ServiceUser } from '../../services/service-user';
import Settings from '../page-settings/PageSettings';
import PageProfile from '../../ts-components/page-profile/PageProfile';
import PageSupplierSelection from '../../ts-components/page-supplier-selection/page-supplier-selection';
import PageInternalBidForm from '../../ts-components/page-internal-bid-form/page-internal-bid-form';
import moment from 'moment';
import PageBidRequest from '../page-bid-request/page-bid-request';
import AppLayout from '../../components/layout/app-layout/app-layout';
import Loading from '../../components/shared/Loading';
import BackButton from '../../components/shared/BackButton/BackButton';
import PageErfaRequest from '../page-erfa-request/page-erfa-request';
import PageScriveRequest from '../page-scrive-request/page-scrive-request';
import PageCategoryMapping from '../page-category-mapping/page-category-mapping';
import PageAreaSupplierAssign from '../page-area-supplier-assign/page-area-supplier-assign';
import CategorySelection from './CategorySelection/CategorySelection';
import { MassMessagingModal } from './MassMessagingModal/MassMessagingModal';
import { withTranslation } from 'react-i18next';
import * as Sentry from '@sentry/react';
import { bucketSettledResults } from '../../util/bulkRunOutcome';
import BtButton from '../bt-button/bt-button';
import { ServiceNextProject } from '../../services/ServiceNextProject';

const projectUrl = 'projects';

// How many purchases a bulk supplier add writes to at once. Low on purpose: each request resolves
// the selected suppliers and writes the project document, so the useful limit is server load, not
// browser sockets. The purchase list caps the selection itself (BULK_ADD_MAX_PURCHASES).
const BULK_ADD_CONCURRENCY = 5;

class PageProjects extends React.Component {
  appPageProjectUsersAreasInstance;
  pagemounted = true;
  appCreateProject;
  supplierDatabase;
  modalAddMember;
  appAddMember;
  elIndustryType;
  socket;

  constructor(props) {
    super(props);
    const role = appState.getRoleFromUrlParams();
    this.state = {
      internOnlyRender: false,
      internOnly: false,
      renderTime: 0,
      updateFlag: false,
      projects: [],
      currentProject: null,
      modalCreateProject: true,
      reLoadSuplleirs: false,
      _colleagues: [],
      colleagues: [],
      editSupplierData: [],
      currentMember: null,
      role,
      modalPageProjectUsersAreasShown: false,
      allAreas: [],
      winningSupplier: [],

      showNewCategoryModal: false,
      areas: [],
      projectList: [],
      users: [],
      isCurrentProjectLoading: true,
      showCreateProjectModal: false,
      submittingArea: false,
      selectedCategories: [],
      creatingNewProject: false,
      showList: false,
      sendToNext: false,
      parentProject: null,
      allNextProjects: [],
      allNextCustomers: [],
      clientValid: false,
    };

    this.refreshCurrentProject = this.refreshCurrentProject.bind(this);
  }

  componentWillUnmount() {
    // No longer setting pagemounted = false. TODO: remove `if (this.pagemounted)` everywhere if everything still works.
    if (this.socket) this.socket.removeAllListeners('chatmessage');
    if (this.obsColleagues) this.obsColleagues.unsubscribe();
    if (this.obsCurrentProject) this.obsCurrentProject.unsubscribe();
    if (this.obsProjects) this.obsProjects.unsubscribe();
  }

  componentDidMount() {
    this.setState({ internOnly: true });
    this.startProccessing();
  }

  async startProccessing() {
    this.socket = ServiceChat.createSocket(appState.getUserToken());
    this.socket.on('chatmessage', x => { this.subscriber(x); });

    try {
      let colleagues = await serviceProfile.getColleagues();
      const chatNotifications = await ServiceChat.getNotifications();
      colleagues.map(x => {
        var result = chatNotifications.filter(n => n.fromUserId == x._id);
        if (result.length) {
          x.notificationCount = result[0].count;
        }
        return x;
      });
      const role = appState.getRoleFromUrlParams();
      const allAreas = await this.fetchAreas();
      const users = await ServiceUser.getTasksUsers();
      const people = users.map(user => ({ label: user.name, value: user._id, projects: user.projects, role: user.role, avatarUrl: user.avatarUrl, isActive: user.isActive }));
      this.setState({ users: people });

      if (this.pagemounted) {
        this.setState({ role, colleagues, allAreas }, () => {
          if (this.isProjectScreen()) this.refreshCurrentProject(true, false);
        });
      }
    } catch (e) {
      console.error('error', e);
    }

    this.bind();

    await this.fetchAreasForNewPurchaseModal();
  }

  async fetchAreas() {
    const mainAreas = await serviceAreas.getAreas(false);
    return [...mainAreas, ...mainAreas.map(o => o.subAreas).flat()];
  }

  async fetchAreasForNewPurchaseModal() {
    // Load all areas for area selector in the modal
    serviceAreas.getAreas().then(result => {
      const areas = result.map(area => {
        const subAreas = area.subAreas.map(subArea => this.formatSubAreaForSelector(subArea, area.name));
        return this.formatAreaForSelector({...area, subAreas});
      });
      this.setState({ areas });
    });
  }

  async fetchAllNextProjects() {
    if (appState.currentOrganization.hasNextProject) {
      try {
        this.setState({ allNextProjects: [] });
        const allNextProjects = await ServiceNextProject.listProjects() ?? [];
        this.setState({ allNextProjects });
      } catch (e) {
        console.log(e);
      }
    }
  }

  async fetchAllNextCustomers() {
    if (appState.currentOrganization.hasNextProject) {
      try {
        const data = await ServiceNextProject.listCustomers();
        this.setState({ allNextCustomers: Array.isArray(data) ? data : [] });
      } catch (e) {
        console.log(e);
      }
    }
  }

  subscriber = async messageObject => {
    const pathName = this.props.location.pathname;
    const urlLength = pathName.split('/').length;
    if (urlLength == 2 && this.state.renderTime < 1 && this.state.internOnly) {
      await ServiceChat.updateNotifications(messageObject.fromUserId);
      this.updateNotification(messageObject.fromUserId);
    }
  };

  checkUrl = (str, strToSearch) => {
    const url = str.split('/');
    return url.find(e => e == strToSearch);
  };

  updateNotification = async id => {
    const { colleagues } = this.state;
    const pathName = this.props.location.pathname;
    const urlLength = pathName.split('/').length;
    if (id !== appState.state.token.id) {
      let i = -1;
      const checkIntern = await colleagues.find((c, _i) => {
        i = _i;
        return c._id == id;
      });
      if (i > -1 && !this.checkUrl(pathName, checkIntern.slug)) {
        // don't notify for opened chat
        this.state.renderTime++;
        if (!pathName.includes(checkIntern.slug) && urlLength == 2 && this.state.internOnly) {
          // check for renderTime when chat not selected
          if(this.pagemounted) this.setState({ internOnlyRender: true });
        }
        if (this.state.renderTime == 1) {
          if (colleagues[i].notificationCount) {
            colleagues[i].notificationCount++;
          } else {
            colleagues[i].notificationCount = 1;
          }
          if (this.internList) {
            this.internList.updateNotification(colleagues);
            if (urlLength > 2) {
              await ServiceChat.updateNotifications(id);
            }
            this.state.renderTime = 0;
          }
        }
      }
    }
  };

  bind() {
    this.obsColleagues = serviceProfile.data$.subscribe(colleagues => {
      if (this.pagemounted) this.setState({ colleagues, __colleagues: colleagues });
    });
    this.obsProjects = ServiceProjects.data$.subscribe(projects => {
      if (this.pagemounted) this.setState({ projects });
    });
    this.obsCurrentProject = ServiceProjects.datacurrent$.subscribe(currentProject => {
      const winningSupplier = [];
      const projectAreas = currentProject.area ?? [];
      projectAreas.filter(r => {
        (r.step == 3 || r.step == 4) &&
          r.suppliers?.filter(_ => {
            if (_.reward) {
              _.areaName = r.areaId.name;
              _.areaId = r.areaId._id;
              winningSupplier.push(_);
            }
          });
      });
      if (this.pagemounted) this.setState({ currentProject, winningSupplier });
    });
  }

  componentDidUpdate() {
    ReactTooltip.rebuild();
    if (!this.state.isCurrentProjectLoading) {
      const pathname = this.props.history.location.pathname;
      let [, , , areaSlug] = this.getUrlComponents(pathname);
      if (areaSlug && pathname.endsWith(areaSlug)) {
        const card = document.getElementById("bidcard-" + areaSlug);
        if (card) {
          card.scrollIntoView();
          this.props.history.replace(pathname.substring(0, pathname.length - areaSlug.length - 1));
        }
      }
    }
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    var newPathName = nextProps.location.pathname;
    var oldPathName = this.props.location.pathname;

    if (oldPathName != newPathName) {
      const role = appState.getRoleFromUrlParams();
      this.setState({ role });

      if (this.isProjectScreen(newPathName) && !this.isSameProject(oldPathName, newPathName)) {
        this.refreshCurrentProject(true);
      } else if (
        this.isProjectScreen(newPathName) && this.isSameProject(oldPathName, newPathName) &&
        oldPathName.includes('/bid-forms') &&
        !newPathName.includes('/bid-forms')
      ) {
        this.refreshCurrentProject(false);
      }

      // scrollbar fix on chat open
      window.location.pathname.split('/').length >= 6
        ? $('.body-wrapper').addClass('conv--wrapper')
        : $('.body-wrapper').removeClass('conv--wrapper');
    }
  }

  parseCurrentStep(currentProject) {
    let currentStep = parseInt(currentProject?.currentStep);
    if (isNaN(currentStep)) currentStep = 0;
    return currentStep;
  }

  getCurrentStep(currentProject) {
    let currentStep = this.parseCurrentStep(currentProject);
    if (currentStep === 5) {
      return 0;
    }
    return currentStep;
  }

  clearNotification = notificationObject => {
    if (!notificationObject || !Object.keys(notificationObject).length) return;

    const { currentProject, projects } = this.state;
    const { keepUnreadCount } = notificationObject;
    const currentProjectAreas = currentProject?.area;

    if (!currentProjectAreas?.length) return;

    const updatedAreas = currentProjectAreas.map(area => {
      const { areaId, suppliers } = area;

      if (areaId?.notification?.length) {
        const areaIndex = areaId.notification.findIndex(
          el => el.supplierMemberId === notificationObject.supplierMemberId && el.areaId === notificationObject.areaId,
        );
        if (areaIndex >= 0) areaId.notification.splice(areaIndex, 1);
      }

      if (suppliers?.length) {
        for (let i = 0; i < suppliers.length; i++) {
          const sup = suppliers[i];
          const { supplierId } = sup;
          if (supplierId?.notification?.length) {
            const supIndex = supplierId.notification.findIndex(
              el => el.supplierMemberId === notificationObject.supplierMemberId && el.areaId === notificationObject.areaId,
            );
            if (supIndex >= 0) {
              if (keepUnreadCount) {
                supplierId.notification[supIndex].count = keepUnreadCount;
              } else {
                supplierId.notification.splice(supIndex, 1);
              }
            }
          }
        }
      }

      return area;
    });

    const updatedProjects = projects.map(pr => {
      if ((pr.notification?.length, pr._id === currentProject._id)) {
        const prIndex = pr.notification.findIndex(
          el => el.supplierMemberId === notificationObject.supplierMemberId,
        );
        if (prIndex >= 0) pr.notification.splice(prIndex, 1);
      }
      return pr;
    });

    this.setState({
      currentProject: { ...currentProject, area: updatedAreas },
      projects: updatedProjects,
    });
  };

  addNotification = notificationObject => {
    if (!notificationObject || !Object.keys(notificationObject).length) return;

    const { currentProject, projects } = this.state;
    const currentProjectAreas = currentProject?.area;

    if (!currentProjectAreas?.length) return;

    const newNotification = {
      supplierMemberId: notificationObject.supplierMemberId,
      areaId: notificationObject.areaId,
      count: 1
    };

    const updatedAreas = currentProjectAreas.map(area => {
      const { areaId, suppliers } = area;

      // Add to supplier's notification array
      if (suppliers?.length) {
        for (let i = 0; i < suppliers.length; i++) {
          const sup = suppliers[i];
          const { supplierId } = sup;
          if (supplierId?._id === notificationObject.supplierId) {
            if (!supplierId.notification) {
              supplierId.notification = [];
            }
            const existingIndex = supplierId.notification.findIndex(
              el => el.supplierMemberId === notificationObject.supplierMemberId && el.areaId === notificationObject.areaId,
            );
            if (existingIndex >= 0) {
              supplierId.notification[existingIndex].count += 1;
            } else {
              supplierId.notification.push({ ...newNotification });
            }
          }
        }
      }

      return area;
    });

    this.setState({
      currentProject: { ...currentProject, area: updatedAreas },
    });
  };

  elAddMailBatchClickCallback(areaSlug, version, copySource, draftDecision) {
    this.setState({
      currentProject: { ...this.state.currentProject },
      version: version >= 0 ? version : null,
    });
    const projectSlug = this.state.currentProject.slug;
    const orgSlug = appState.getCurrentOrgSlug();
    let history = this.props.history;
    const sourceParam = copySource ?? "";
    const draftParam = draftDecision
      ? (sourceParam ? "&" : "?") + "draftDecision=" + draftDecision
      : "";

    history.push(`/${orgSlug}/projects/${projectSlug}/${areaSlug}/bid-request/${version >= 0 ? version + 1 : "new"}${sourceParam}${draftParam}`, {});
  }

  historycurrentProject() {
    let [, , id] = this.getUrlComponents(this.props.history.location.pathname);
    return id;
  }

  isProjectScreen(newUrl = this.props.location.pathname) {
    const newUrlComponents = this.getUrlComponents(newUrl);
    return newUrlComponents[1] == projectUrl; //update check project path
  }

  isSameProject(oldUrl, newUrl) {
    const oldUrlComponents = this.getUrlComponents(oldUrl);
    const newUrlComponents = this.getUrlComponents(newUrl);
    return !!(
      oldUrlComponents[1] == projectUrl &&
      newUrlComponents[1] == projectUrl &&
      oldUrlComponents[2] == newUrlComponents[2]
    );
  }

  getUrlComponents(url) {
    return url?.split('/').filter(el => el != '') || [];
  }

  editProjectBtnCallback(currentProject) {
    this.setState({ createDialogCurrentProject: currentProject });
    this.setState({ showCreateProjectModal: true });
  }

  editMemberBtnCallback = async (currentMember) => {
    await this.getProjectList();
    this.setState({
      currentMember: currentMember,
      showModalAddMember: true,
    });
  }

  getProjectList = async () => {
    let projectList = await ServiceProjects.getProjectList();
    this.setState({ projectList })
  }

  async handleProjectUpdateCreated(sender, project) {
    if (this.state.sendToNext && appState.currentOrganization.nextProjectAllowExport) {
      try {
        await ServiceNextProject.exportProject(project._id, this.appCreateProject?.state.parentProject?.value);
        this.setState({ sendToNext: false });
      } catch (err) {
        NotificationManager.error(err?.response?.data?.error || this.props.t('notification.error.sending.project.to.next', 'Det gick inte att skicka projektet till Next Project.'));
      }
    }
    const orgSlug = appState.getCurrentOrgSlug();
    this.setState({ showCreateProjectModal: false, parentProject: null });
    
    let history = this.props.history;

    project.createdAt = new Date().getTime();
    ServiceProjects.setCurrent(project);

    setTimeout(() => {
      history.push(`/${orgSlug}/projects/${btDirname(project.slug)}`, {});
    }, 1000);
  }

  addProjectBtnCallback() {
    let showCount = this.state.createProjectShowCount || 0;
    this.setState({ createProjectShowCount: ++showCount, showCreateProjectModal: true, clientValid: false });
  }

  closeCreateProjectModal = () => this.setState({ showCreateProjectModal: false, parentProject: null, clientValid: false });

  handleParentProjectChange = (v) => this.setState({ parentProject: v });

  btnAddSupplierClick(selectedArea) {
    let history = this.props.history;
    console.log(`/${appState.getCurrentOrgSlug()}/projects/${this.state.currentProject.slug}/${selectedArea.areaId.slug}/supplier-selection`);
    history.push(`/${appState.getCurrentOrgSlug()}/projects/${this.state.currentProject.slug}/${selectedArea.areaId.slug}/supplier-selection`, {});
  }

  saveSuppliersHandler = async (sender, supplierIds, bidData, bulkAreaIds) => {
    if (Array.isArray(bulkAreaIds) && bulkAreaIds.length) {
      return this.saveSuppliersToManyAreas(supplierIds, bulkAreaIds);
    }

    try {
      let currentProject = this.state.currentProject;
      const area = currentProject.area.find(area => area.areaId.slug === window.location.pathname.split('/')[4]);
      let projectSlug = currentProject.slug;
      let areaId = area.areaId._id;
      let areaSlug = area.areaId.slug;
      let suppliers = bidData?.suppliers && JSON.parse(bidData.suppliers);

      this.setState({ showSupplierSavingLoading: true });
      const response = await ServiceProjects.dbAddSuppliers(
        projectSlug,
        areaId,
        supplierIds,
        bidData,
      );

      if (bidData?.extendedContactPersons && suppliers) {
        const expDate = new Date(bidData.quotationExpiryDate);
        // Update expiry only when quotation is expired
        if (moment().isAfter(expDate) && suppliers?.length){
          suppliers.map(sup =>
            ServiceProjects.changeSupplierDate(projectSlug, areaSlug, sup.supplierId, expDate),
          );
        }
      }

      this.setState({ showSupplierSavingLoading: false });

      let areaSuppliers = response.suppliers.map(ss => ({ supplierId: ss }));

      ServiceProjects.replaceAreaSuppliersBySlug(projectSlug, areaId, areaSuppliers);
    } catch (error) {
      console.log('error-----', error);
      this.setState({ showSupplierSavingLoading: false });
    }

    this.props.history.goBack();
  };

  /**
   * Adds the same suppliers to several purchases. Never sends a bid request — each purchase has
   * its own, so there is no single one to send; the API only sends when bid data is supplied.
   * Reports per purchase rather than as one pass/fail, so a partial add can't read as success.
   *
   * Runs in batches of BULK_ADD_CONCURRENCY; see the comment at the loop.
   */
  saveSuppliersToManyAreas = async (supplierIds, areaIds) => {
    const { t } = this.props;
    const currentProject = this.state.currentProject;
    const projectSlug = currentProject.slug;
    // Falls back to a placeholder rather than '': a purchase deleted between selecting suppliers
    // and saving no longer resolves, and an empty string would leave the failure message naming
    // nothing at all ("... i 1 upphandlingar: ").
    const nameFor = areaId =>
      currentProject.area.find(a => a.areaId._id === areaId)?.areaId?.name
      || t('purchaseList.bulkActions.unknownPurchase', 'okänd upphandling');

    this.setState({ showSupplierSavingLoading: true });
    try {
      const addToArea = async areaId => {
        const response = await ServiceProjects.dbAddSuppliers(projectSlug, areaId, supplierIds, null);
        try {
          // Local cache sync only — the server already committed, so a throw here must not put the
          // purchase in the failed bucket; a retry would then report it as already present.
          ServiceProjects.replaceAreaSuppliersBySlug(
            projectSlug,
            areaId,
            (response.suppliers ?? []).map(ss => ({ supplierId: ss }))
          );
        } catch (error) {
          Sentry.captureException(error, { extra: { bulkAction: 'addSuppliers', stage: 'localSync', areaId } });
        }
        // The route answers 200 whether it wrote or not; `added` says which. A purchase where every
        // selected supplier was already present is a skip, not a success — counting it as added is
        // how "Leverantörer tillagda i 5 upphandlingar" used to describe a run that changed nothing.
        // (Strict equality: a response without the field keeps the old count-the-200 behaviour.)
        if (response.added === 0) return 'already-present';
      };

      // In batches rather than all at once: one request per purchase, each resolving suppliers and
      // writing the project document, so a whole-project selection would otherwise put every one
      // of them in flight together. The action bar caps the selection; this caps what that
      // selection does to the server at any instant.
      const results = [];
      for (let i = 0; i < areaIds.length; i += BULK_ADD_CONCURRENCY) {
        const batch = areaIds.slice(i, i + BULK_ADD_CONCURRENCY);
        results.push(...await Promise.allSettled(batch.map(addToArea)));
      }

      const items = areaIds.map(areaId => ({ id: String(areaId), name: nameFor(areaId) }));
      const outcome = bucketSettledResults(results, items);
      outcome.failed.forEach(({ name, reason }) =>
        Sentry.captureException(reason, { extra: { bulkAction: 'addSuppliers', areaName: name } }));

      if (outcome.changed > 0) {
        NotificationManager.success(t('purchaseList.bulkActions.suppliersAdded',
          'Leverantörer tillagda i {{count}} upphandlingar', { count: outcome.changed }));
      }
      const alreadyPresent = outcome.skippedByReason['already-present'] ?? [];
      if (alreadyPresent.length > 0) {
        NotificationManager.info(t('purchaseList.bulkActions.suppliersAlreadyPresent',
          'Leverantörerna fanns redan i {{count}} upphandlingar', { count: alreadyPresent.length }));
      }
      if (outcome.failed.length) {
        NotificationManager.error(
          t('purchaseList.bulkActions.suppliersAddFailed',
            'Leverantörer kunde inte läggas till i {{count}} upphandlingar: {{names}}',
            { count: outcome.failed.length, names: outcome.failed.map(f => f.name).join(', ') }),
          t('purchaseList.bulkActions.failedTitle', 'Misslyckat')
        );
      }
    } finally {
      this.setState({ showSupplierSavingLoading: false });
      this.props.history.goBack();
    }
  };

  updateEditSupplierData(data) {
    let formData = {
      city: [],
      name: '',
      supplierId: '',
      areaIds: [],
      organizationNumber: '',
    };

    if (data.length) {
      formData.kommun = { label: data.kommun, value: data.kommun };
      formData.name = data.name;
      formData.city = data.city;
      formData.organizationNumber = data.organizationNumber;
      formData.vatNumber = data.vatNumber;
      formData.website = data.website;
      formData.address = data.address;
      formData.isBlacklist = data.isBlacklist ? data.isBlacklist : false;
      formData.blacklistReason = data.blacklistReason ?? [];
      formData.address = data.address;
      formData.postnumber = data.postnumber;
      formData.supplierId = data._id;
      formData.areaIds = data.areaIds?.map((row) => row._id) ?? [];
    }

    this.setState({ editSupplierData: formData });
  }

  handleStrategyUpdated(sender, newStrategy) {
    const {t} = this.props;
    let currentProject = this.state.currentProject;
    let projectSlug = currentProject.slug;

    ServiceProjects.replaceStrategyBySlug(projectSlug, newStrategy);

    NotificationManager.success(
      t('notification.success.description.strategyUpdated', 'Strategin sparad.'),
      t('notification.success.title.strategyUpdated', 'Sparad')
    );
  }

  async validateNewStep(newStep) {
    const currentProject = this.state.currentProject;
    if (!currentProject) return true;

    let projectSlug = currentProject.slug;
    ServiceProjects.dbUpdateProjectCurrentStep(projectSlug, newStep);
    if (this.pagemounted) {
      this.setState({ currentStep: newStep });
    }
    return false;
  }

  toggleModalPageProjectUsersAreas = async () => {
    await this.fetchAreasForNewPurchaseModal();
    this.setState({
      showNewCategoryModal: true,
      showList: false,
      selectedCategories: []
    });
  };

  onErfa = () => {
    const history = this.props.history;
    const projectSlug = this.state.currentProject.slug;
    const orgSlug = appState.getCurrentOrgSlug();

    history.push(`/${orgSlug}/projects/${projectSlug}/erfa`);
  }

  contractUploadHandler = (sender, area) => {
    const history = this.props.history;
    const projectSlug = this.state.currentProject.slug;
    const orgSlug = appState.getCurrentOrgSlug();
    history.push(`/${orgSlug}/projects/${projectSlug}/${area?.areaId?.slug}/scrive`);
  }

  async removeProject(projectId, projectName, projectSlug) {
    if (window.confirm(this.props.t('confirm.removeProject', 'Är du säker på att du vill radera detta projekt {{projectName}}?', { projectName }))) {
      await ServiceProjects.deleteProject(projectSlug);
      ServiceProjects.remove(projectId);
      return true;
    }
    return false;
  }

  async clearNotifications(projectId, projectName) {
    if (window.confirm(this.props.t('confirm.clearNotifications', 'Markera alla meddelanden i {{projectName}} som lästa? Detta går inte att ångra.', { projectName }))) {
      await ServiceProjects.clearNotifications(projectId);
      await appState.refreshProjectNotifications();
      return true;
    }
    return false;
  }

  async clearAllNotifications() {
    if (window.confirm(this.props.t('confirm.clearAllNotifications', 'Markera alla meddelanden i alla projekt som lästa? Detta går inte att ångra.'))) {
      await ServiceProjects.clearAllNotifications();
      await appState.refreshProjectNotifications();
      return true;
    }
    return false;
  }

  checkRole(role, project) {
    if (this.state.role !== appEnum.Role.Supplier && role == appEnum.Role.Supplier) {
      this.setState({ role: role });
    }
    if (project) {
      this.setState({ currentProject: project });
    }
  }

  setCurrentData(payload) {
    this.setState({ payload: payload });
  }

  toggleProjectStatus = async () => {
    const {t} = this.props;
    let slug = this.state.currentProject.slug;
    const status = this.state.currentProject.isOpen ? false : true;

    await ServiceProjects.updateProjectOpenStatus(slug, status);
    ServiceProjects.replaceIsOpenBySlug(slug, status);

    NotificationManager.success(
      t('notification.success.description.statusUpdated', 'Statusen har blivit uppdaterad.'),
      t('notification.success.title.statusUpdated', 'Ändring utförd')
    );
  };

  renderWizard({match}) {
    const {t} = this.props;
    const { currentProject, currentStep } = this.state;
    const look = "new";
    const setLook = async look => {
      await ServiceUser.updatePreferences(
        appState.getUserId(),
        { enabled: look == "new" },
        appEnum.userPrefrences.listViewBeta
      );
      await appState.getUserDetails();
    }

    // let projectSlug = currentProject?.slug;
    const areaSlug = match.params.area;
    // const strategy = currentProject?.strategy;
    const setCurrentProject = (project) => this.setState({currentProject: project});
    const steps = [
      // {
      //   name: t('steps.strategy', 'Strategi'),
      //   step: 0,
      //   component: (
      //     <ProjectStrategy
      //       onStepChange={this.handleAccordionStepChange}
      //       currentProject={currentProject}
      //       setCurrentProject={setCurrentProject}
      //       projectSlug={projectSlug}
      //       strategy={strategy}
      //       editProjectBtnCallback={this.editProjectBtnCallback.bind(this)}
      //       onStrategyUpdated={this.handleStrategyUpdated.bind(this)}
      //       onNewArea={this.toggleModalPageProjectUsersAreas}
      //       onErfa={this.onErfa}
      //       onToggleProjectStatus={this.toggleProjectStatus}
      //       look={look}
      //       setLook={setLook}
      //       history={this.props.history}
      //     />
      //   ),
      // },
      {
        name: t('steps.purchasePlan', 'Inköpsplan'),
        step: 6,
        component: (
          <PageProjectsSingle
            onStepChange={this.handleAccordionStepChange}
            currentProject={currentProject}
            setCurrentProject={setCurrentProject}
            step={6}
            allowEditing={true}
            isWinnerEditable={true}
            editProjectBtnCallback={this.editProjectBtnCallback.bind(this)}
            isContractSigning={true}
            contractUploadEvent={this.contractUploadHandler.bind(this)}
            refreshCurrentProject={this.refreshCurrentProject}
            onNewArea={this.toggleModalPageProjectUsersAreas}
            onErfa={this.onErfa}
            onToggleProjectStatus={this.toggleProjectStatus}
            users={this.state.users}
            addSupplier={this.btnAddSupplierClick.bind(this)}
            createNewVersion={this.elAddMailBatchClickCallback.bind(this)}
            selectedArea={areaSlug}
            look={look}
            setLook={setLook}
            history={this.props.history}
          />
        ),
      },
      {
        name: t('steps.request', 'Förfrågan'),
        step: 1,
        component: (
          <PageProjectsSingle
            onStepChange={this.handleAccordionStepChange}
            currentProject={currentProject}
            setCurrentProject={setCurrentProject}
            step={1}
            allowEditing={true}
            isWinnerEditable={false}
            editProjectBtnCallback={this.editProjectBtnCallback.bind(this)}
            contractUploadEvent={this.contractUploadHandler.bind(this)}
            refreshCurrentProject={this.refreshCurrentProject}
            onNewArea={this.toggleModalPageProjectUsersAreas}
            onErfa={this.onErfa}
            onToggleProjectStatus={this.toggleProjectStatus}
            users={this.state.users}
            addSupplier={this.btnAddSupplierClick.bind(this)}
            createNewVersion={this.elAddMailBatchClickCallback.bind(this)}
            selectedArea={areaSlug}
            look={look}
            setLook={setLook}
            history={this.props.history}
          />
        ),
      },
      {
        name: t('steps.evaluation', 'Utvärdering'),
        step: 2,
        component: (
          <PageProjectsSingle
            onStepChange={this.handleAccordionStepChange}
            currentProject={currentProject}
            setCurrentProject={setCurrentProject}
            step={2}
            allowEditing={true}
            isWinnerEditable={true}
            editProjectBtnCallback={this.editProjectBtnCallback.bind(this)}
            contractUploadEvent={this.contractUploadHandler.bind(this)}
            onNewArea={this.toggleModalPageProjectUsersAreas}
            onErfa={this.onErfa}
            onToggleProjectStatus={this.toggleProjectStatus}
            refreshCurrentProject={this.refreshCurrentProject}
            users={this.state.users}
            addSupplier={this.btnAddSupplierClick.bind(this)}
            createNewVersion={this.elAddMailBatchClickCallback.bind(this)}
            selectedArea={areaSlug}
            look={look}
            setLook={setLook}
            history={this.props.history}
          />
        ),
      },
      {
        name: t('steps.negotiation', 'Förhandling'),
        step: 3,
        component: (
          <PageProjectsSingle
            onStepChange={this.handleAccordionStepChange}
            currentProject={currentProject}
            setCurrentProject={setCurrentProject}
            lastStep={true}
            allowEditing={true}
            isContractSigning={true}
            step={3}
            editProjectBtnCallback={this.editProjectBtnCallback.bind(this)}
            contractUploadEvent={this.contractUploadHandler.bind(this)}
            onNewArea={this.toggleModalPageProjectUsersAreas}
            onErfa={this.onErfa}
            onToggleProjectStatus={this.toggleProjectStatus}
            refreshCurrentProject={this.refreshCurrentProject}
            users={this.state.users}
            addSupplier={this.btnAddSupplierClick.bind(this)}
            createNewVersion={this.elAddMailBatchClickCallback.bind(this)}
            selectedArea={areaSlug}
            look={look}
            setLook={setLook}
            history={this.props.history}
          />
        ),
      },
      {
        name: t('steps.agreement', 'Avtal'),
        step: 4,
        component: (
          <PageProjectsSingle
            onStepChange={this.handleAccordionStepChange}
            currentProject={currentProject}
            setCurrentProject={setCurrentProject}
            lastStep={true}
            allowEditing={true}
            isContractSigning={true}
            step={4}
            editProjectBtnCallback={this.editProjectBtnCallback.bind(this)}
            contractUploadEvent={this.contractUploadHandler.bind(this)}
            onNewArea={this.toggleModalPageProjectUsersAreas}
            onErfa={this.onErfa}
            onToggleProjectStatus={this.toggleProjectStatus}
            refreshCurrentProject={this.refreshCurrentProject}
            users={this.state.users}
            addSupplier={this.btnAddSupplierClick.bind(this)}
            createNewVersion={this.elAddMailBatchClickCallback.bind(this)}
            selectedArea={areaSlug}
            look={look}
            setLook={setLook}
            history={this.props.history}
          />
        ),
      }
    ];
    if (currentStep !== undefined && steps.find(x => x.step === currentStep)) {
      return steps.find(x => x.step === currentStep).component;
    } else {
      return currentProject ? steps[0].component : <div></div>;
    }
  }

  handleAccordionStepChange = _newStep => {
    this.validateNewStep(_newStep);
    const { history } = this.props;
    const locationArray = history.location.pathname.split('/').filter(n => n);
    const baseLocation = locationArray.filter((el, i) => i < 3).join('/');

    console.log("handle accordion step change")
    if (locationArray.length > 2 && !appState.getListViewBetaPreference()) {
      console.log("pushing ", baseLocation);
      history.push(`/${baseLocation}`);
    }
  };

  renderContent() {
    const {
      showSupplierSavingLoading,
      currentProject,
      areas
    } = this.state;
    let browserHistory = this.props.history;
    const url = appState._getCurrentOrgUrl();

    return (
      <Router history={browserHistory}>
        <Switch>
          <Route exact path={`${url}/projects`} render={() => (
              <PageProjectsStart
                history={browserHistory}
                projects={this.state.projects}
                addProject={this.addProjectBtnCallback.bind(this)}
                removeProject={this.removeProject.bind(this)}
                clearNotifications={this.clearNotifications.bind(this)}
                clearAllNotifications={this.clearAllNotifications.bind(this)}
                allNextProjects={this.state.allNextProjects}
                fetchAllNextProjects={this.fetchAllNextProjects.bind(this)}
                allNextCustomers={this.state.allNextCustomers}
                fetchAllNextCustomers={this.fetchAllNextCustomers.bind(this)}
              />
            )}
          />
          <Route path={`${url}/projects/:project/:areaSlug/tips`} exact component={PageTips} />
          <Route
            path={`${url}/organizations/applications`}
            render={() => <PageOrganizationApplications />}
          />
          <Route
            path={`${url}/organizations`}
            render={() => <Organization />}
          />
          <Route
            path={`${url}/supplier-database/monitoring`}
            render={props => <PageSupplierMonitoring {...props} />}
          />
          <Route
            path={`${url}/supplier-database`}
            render={({ location }) => (
              <SupplierDatabase
                key={matchPath(location.pathname, `${url}/supplier-database/featured`) ? 'featured-supplier' : 'register'}
                history={browserHistory}
                modifySuppName={this.state.modifySuppName}
                updateEditSupplierData={this.updateEditSupplierData.bind(this)}
                editSupplierData={this.state.editSupplierData}
                reLoadSuplleirs={this.state.reLoadSuplleirs}
                supplierDatabase={this.supplierDatabase}
              />
            )}
          />
          <Route
            path={`${url}/categories/:slug`}
            render={ props => <PageCategoryMapping {...props} category={props.match.params.slug} /> }
          />
          <Route
            exact
            path={`${url}/area/:areaId/suppliers`}
            render={({ match, location }) => (
              <PageAreaSupplierAssign
                match={match}
                area={location.state?.area}
                showLoading={false}
                onSaveClick={() => { }}
                t={this.props.t}
              />
            )}
          />
          <Route
            path={`${url}/chat/:id`}
            render={props => (
              <PageInternalChat
                internOnlyRender={this.state.internOnlyRender}
                internOnly={this.state.internOnly}
                updateNotification={this.updateNotification}
                {...props}
                editMemberBtnCallback={this.editMemberBtnCallback}
              />
            )}
          />
          <Route path={`${url}/chat`} render={ props => <PageProjectInternList {...props} /> } />
          <Route path={`${url}/settings`} render={() => <Settings />} />
          <Route path={`${url}/profile`} render={() => <PageProfile />} />
          {!this.state.isCurrentProjectLoading ?
            (<Switch>
                <Route
                  exact
                  path={`${url}/projects/:project/erfa`}
                  render={(props) => <PageErfaRequest currentProject={currentProject} {...props} />}
                />
                <Route
                  exact
                  path={`${url}/projects/:project/:areaSlug/scrive`}
                  render={(props) => <PageScriveRequest currentProject={currentProject} {...props} />}
                />
                <Route
                  exact
                  path={`${url}/projects/:project/:areaSlug/manual-contract`}
                  render={(props) => <PageScriveRequest currentProject={currentProject} {...props} />}
                />
                <Route
                  exact
                  path={`${url}/projects/:project/:areaSlug/bid-request/:version`}
                  render={(props) => <PageBidRequest currentProject={currentProject} {...props} />}
                />
                <Route
                  exact
                  path={`${url}/projects/:project/:areaSlug/bid-forms/:supplierSlug?`}
                  component={PageInternalBidForm}
                />
                <Route
                  exact
                  path={`${url}/projects/:project/:areaSlug/supplier-selection`}
                  render={({match, location}) => (
                    <PageSupplierSelection
                      match={match}
                      location={location}
                      areas={areas}
                      currentProject={currentProject}
                      onSaveClick={this.saveSuppliersHandler}
                      showLoading={showSupplierSavingLoading}
                    />
                  )}
                />
                <Route
                  exact
                  path={`${url}/projects/:project/:type/:supplier/:supplierMember?`}
                  render={props => {
                    return (
                      <PageProjectsSingleInbox
                        {...props}
                        checkRole={this.checkRole.bind(this)}
                        setCurrentData={this.setCurrentData.bind(this)}
                        role={this.state.role}
                        currentProject={currentProject}
                        clearNotification={this.clearNotification}
                        addNotification={this.addNotification}
                        refreshCurrentProject={this.refreshCurrentProject}
                      />
                    );
                  }}
                />
                <Route path={`${url}/projects/:project/:area?`} render={this.renderWizard.bind(this)} />
              </Switch>)
           : (
            <AppLayout
            title={
               <BackButton
                path={["..."]}
                onClick={() => history.go(`${url}/projects`)}
               />}
               >

            <div style={{display:"flex", width:"100%", height:"100%", justifyContent:"center", alignItems:"center"}}><Loading type="inline" /></div>
            </AppLayout>
          )}
        </Switch>
      </Router>
    );
  }

  async refreshCurrentProject(initialLoadProjectFromList, showLoader = true) {
    const projectSlug = this.historycurrentProject();
    if (!projectSlug) return;

    let currentProject = initialLoadProjectFromList ? ServiceProjects.getProjectBySlug(projectSlug) : this.state.currentProject;

    if (this.pagemounted && showLoader) this.setState({ isCurrentProjectLoading: true, currentProject });

    const projects = await ServiceProjects.getProject(projectSlug);
    currentProject = projects?.length ? projects[0] : null;

    if (this.pagemounted) {
      this.setState({
        currentProject,
        currentStep: this.getCurrentStep(currentProject),
        isCurrentProjectLoading: false,
      });
    }
    ServiceProjects.setCurrent(currentProject);
  }

  addArea = async (selectedArea) => {
    let slug = this.state.currentProject.slug;
    const areaId = selectedArea.areaId._id;
    await ServiceProjects.dbAddArea(slug, areaId);
  };

  formatAreaForSelector = (area) => {
    return { _id: area._id, label: area.name, value: area.slug, accountNumber: area.accountNumber, subAreas: area.subAreas, __isNew__: area.__isNew__ }
  }
  formatSubAreaForSelector = (subArea, areaName) => {
    return { _id: subArea._id, label: subArea.name.replace(new RegExp(`-${areaName}$`), ''), value: subArea.slug, __isNew__: subArea.__isNew__ };
  }

  render() {
    const {t} = this.props;
    const {
      currentProject,
      role,
      createDialogCurrentProject,
      createProjectShowCount,
      showNewCategoryModal,
      areas,
      selectedCategories,
    } = this.state;
    const currentProjectAreas = currentProject?.area;
    const isSupplier = role == appEnum.Role.Supplier;

    const onCreateProject = () => {
      this.appCreateProject?.btnCreateProjectClickCallback()
    }
    const onSaveHandler = async () => {
      this.setState({ submittingArea: true });

      try {
        const newCategories = selectedCategories.filter(selectedCategory =>
          !(currentProjectAreas || []).some(projectArea =>
            projectArea.areaId.slug === (selectedCategory.subCategory?.value ? selectedCategory.subCategory?.value : selectedCategory.mainCategory?.value)));
        const formattedSelectedCategories = newCategories.map(selectedCategory => {
          return {
            mainCategory: {
              _id: selectedCategory.mainCategory._id,
              name: selectedCategory.mainCategory.label,
            },
            subCategory: {
              _id: selectedCategory.subCategory?._id,
              name: selectedCategory.subCategory?.label,
              isNew: selectedCategory.subCategory?.__isNew__,
            }
          }
        });
        await serviceAreas.addAreaBatch(this.state.currentProject.slug, formattedSelectedCategories);

        await this.refreshCurrentProject();
        const allAreas = await serviceAreas.getAreas(true);
        const tempAreas = this.state.areas.map(area => {
          const subAreas = allAreas.find(_area => _area._id === area._id)?.subAreas;
          return {
            ...area,
            subAreas: subAreas.map(subArea => this.formatSubAreaForSelector(subArea, area.label)),
          }
        });
        this.setState({
          areas: tempAreas,
          allAreas,
          showNewCategoryModal: false,
          submittingArea: false,
          selectedCategories: []
        });
      } catch (e) {
        this.setState({
          submittingArea: false,
        })
      }
    }

    const shouldSaveButtonBeDisabled = () => {
      if (!selectedCategories || selectedCategories.length === 0) {
        return true;
      }

      if (this.state.showList) {
        return selectedCategories.every(selectedCategory => currentProjectAreas.find(projectArea => projectArea.areaId.slug === selectedCategory.mainCategory?.value));
      }
      const isDisabled = selectedCategories.some(selectedCategory => {
        const mainAreaSelected = selectedCategory?.mainCategory?.label;
        const subAreaSelected = selectedCategory?.subCategory?.label;
        const mainAreaIsSelectedInProject = mainAreaSelected && currentProjectAreas?.find(area => area.areaId.name === mainAreaSelected);
        const mainAreaAndSubAreaCombinationAlreadyExistsOnSelectedCategories = mainAreaSelected && selectedCategories.find(_selectedCategory =>
          _selectedCategory.id !== selectedCategory.id &&
          _selectedCategory.mainCategory?.value === selectedCategory.mainCategory?.value &&
          _selectedCategory.subCategory?.value === selectedCategory.subCategory?.value
        );

        return !mainAreaSelected || (mainAreaIsSelectedInProject && !subAreaSelected) || mainAreaAndSubAreaCombinationAlreadyExistsOnSelectedCategories;
      });

      return isDisabled;
    };

    const projectCreateButtonText = createDialogCurrentProject?._id ? t('createProject.button.edit', 'Spara') : t('createProject.button.create', 'Skapa');

    return (
      <div className={`page-projects ${isSupplier ? 'only--quotation' : ''}`}>
        {this.renderContent()}

        <Modal
          title={createDialogCurrentProject?._id ? t('createProject.title.edit', 'Redigera projekt') : t('createProject.title.create', 'Nytt projekt')}
          show={this.state.showCreateProjectModal}
          buttonInfo={{
            label: projectCreateButtonText + (this.state.parentProject ? t('createProject.button.sendTo', ' och skicka till Next') : ''),
            action: () => {
              if (this.state.parentProject) {
                this.setState({ sendToNext: true });
              }
              onCreateProject();
            },
            loaderShow: this.appCreateProject?.state.loaderShow,
            disabled: !!this.state.parentProject && !this.state.clientValid,
          }}
          setShow={this.closeCreateProjectModal}
          unmountWhenHidden
        >
          <AppCreateProject
            ref={el => (this.appCreateProject = el)}
            currentProject={createDialogCurrentProject}
            showCount={createProjectShowCount}
            users={this.state.users}
            onProjectUpdateCreated={this.handleProjectUpdateCreated.bind(this)}
            onParentProjectChange={this.handleParentProjectChange}
            onCustomerMappingChange={(valid) => this.setState({ clientValid: valid })}
            allNextProjects={this.state.allNextProjects}
            fetchAllNextProjects={this.fetchAllNextProjects.bind(this)}
            allNextCustomers={this.state.allNextCustomers}
            fetchAllNextCustomers={this.fetchAllNextCustomers.bind(this)}
          />
        </Modal>
        <Modal
          title={t('newCategoryModal.heading', 'Ny upphandling')}
          show={showNewCategoryModal}
          setShow={(value) => this.setState({ showNewCategoryModal: value, })}
          buttonInfo={{
            label: t('newCategoryModal.button', 'Skapa'),
            disabled: shouldSaveButtonBeDisabled(),
            action: onSaveHandler,
            loaderShow: this.state.submittingArea
          }}
          containerBeforeButtons={this.state.showList && (
            <span style={{ color: 'var(--gray-700)', fontSize: 14, display: 'flex', alignItems: 'center', gap: '8px', width: '100%' }}>
              <BtButton color='white' onClick={() => this.setState({ selectedCategories: [] })} disabled={selectedCategories.length === 0}>{t('newCategoryModal.clear', 'Rensa')}</BtButton>
              <span>{selectedCategories.length} {t('newCategoryModal.selected', 'valda')}</span>
            </span>
          )}
        >
          <CategorySelection
            selectedCategories={selectedCategories}
            setSelectedCategories={(getNewState) => this.setState((prevState) => ({
              ...prevState,
              selectedCategories: getNewState(prevState.selectedCategories)
            }))}
            currentProjectAreas={currentProjectAreas}
            areas={areas}
            closeButtonText="Stäng"
            showList={this.state.showList}
            setShowList={(value) => this.setState({ showList: value })}
          />
        </Modal>

        <MassMessagingModal projectId={this.state.currentProject?._id} />
      </div>
    );
  }
}

export default withRouter(withTranslation('projects')(PageProjects));
